const mixin = {
  data () {
    return {
      userSettings: {}
    }
  },


  methods: {
    setUserSettings () {
      localStorage.setItem('pUserSettings', JSON.stringify(this.userSettings))
    },

    checkoutUserSettings () {
      if (localStorage.getItem('pUserSettings')) {
        this.userSettings = JSON.parse(localStorage.getItem('pUserSettings'))
      }
    }
  },


  created () {
    this.checkoutUserSettings()
  }
}

export default mixin
